import { track } from "@/features/analytics";
import { cn } from "@lib/cn";
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightCollapse,
} from "@tabler/icons-react";
import { useSidebarStoreShallow } from "../store";

/**
 * Collapse / expand toggle for the left sidebar. Rendered in the base
 * layout header so it stays reachable even when the sidebar itself is
 * collapsed to the narrow rail.
 */
export const SidebarToggle = ({ className }: { className?: string }) => {
  const { isOpen, toggleSidebar } = useSidebarStoreShallow((s) => ({
    isOpen: s.isOpen,
    toggleSidebar: s.toggleSidebar,
  }));

  const handleClick = () => {
    track("toggle sidebar", { "is open": !isOpen });
    toggleSidebar();
  };

  return (
    <button
      type="button"
      aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
      onClick={handleClick}
      className={cn(
        "tw-flex tw-size-8 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-outline-none tw-transition-colors hover:tw-bg-blue-100",
        className,
      )}
    >
      {isOpen ? (
        <IconLayoutSidebarLeftCollapse className="tw-size-4 tw-text-blue-500" />
      ) : (
        <IconLayoutSidebarRightCollapse className="tw-size-4 tw-text-blue-500" />
      )}
    </button>
  );
};
